import { render, staticRenderFns } from "./linehaul-road-edit-page.vue?vue&type=template&id=b39f2b48"
import script from "./linehaul-road-edit-page.vue?vue&type=script&lang=ts"
export * from "./linehaul-road-edit-page.vue?vue&type=script&lang=ts"
import style0 from "./linehaul-road-edit-page.vue?vue&type=style&index=0&id=b39f2b48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports